// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3boYf","selects":"Documents_selects__3jPz8"};